import { render, staticRenderFns } from "./MultiError.vue?vue&type=template&id=28fc464e"
import script from "./MultiError.vue?vue&type=script&lang=js"
export * from "./MultiError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports